import React, { Fragment, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { StatusInitialsForAdd, StatusInitialsForUpdate } from "./interfaces/StatusClass";
import { addAccountStatusAsync, updateAccountStatusAsync, resetSelectedRecordObjectInState } from "./StatusSlice";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';



export const StatusForm = (props: any) => {
    const { modelRef, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(StatusInitialsForAdd);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.status);
    const dispatch = useAppDispatch();
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    const [statusTypeArray, SetstatusTypeArray] = useState<any | ''>([]);
    const [selectedOptionRadio, setSelectedOptionRadio] = useState(false);
    const masterAccountStatusIds = [6, 14, 2, 10];
    const { maxMenuHeight, manageTerminologyList} = useAppSelector((state) => state.globalState);

    const getStatusTypesAsync = async () => {
        const response = await fetchAPI("api/v2/Status/StatusTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const jsonResponse = await response.json();
        const json = jsonResponse.Data;
        // json.map((item: any) => {
        //     item.value = item.SystemStatusTypeId;
        //     item.label = item.SystemStatusType;
        //     delete item.SystemStatusTypeId;
        //     delete item.SystemStatusType;
        // });
        const modifiedJSON = json.map((item: any) => ({
            value: item.SystemStatusTypeId,
            label: item.SystemStatusType,
        }));
        SetstatusTypeArray(modifiedJSON);
        if (Object.keys(selectedRecord).length === 0 && modifiedJSON.length > 0) {
            setSelectedOptionDropDown(modifiedJSON[0]);
            setCurrentFieldsData((prev: any) => ({
                ...prev,
                StatusTypeId: modifiedJSON[0].value,
            }));
        }
    }

    // useEffect(() => {
    //     getStatusTypesAsync();
    // }, [])

    useEffect(() => {
        getStatusTypesAsync();
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(StatusInitialsForUpdate).map((item) => {

                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(StatusInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

    }, [selectedRecord])

    useEffect(() => {
        let stateItem: any = {}

        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(StatusInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsClosed = stateItem.IsClosed === 'Yes' ? true : false;
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            setSelectedOptionRadio(stateItem.IsClosed);
            setCurrentFieldsData(stateItem);
            setSelectedOptionDropDown({ value: stateItem.StatusTypeId, label: stateItem.SystemStatusType });
        }
        else {
            setSelectedOptionRadio(false);
            setCurrentFieldsData(StatusInitialsForAdd);
        }
    }, [selectedRecord])

    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const handleChange = (data: any) => {
        const { value, label } = data;
        setSelectedOptionDropDown({ value: value, label: label });
        setCurrentFieldsData({ ...currentFieldsData, 'StatusTypeId': value });
    };
    const handleOptionChange = (event: any) => {
        setSelectedOptionRadio(JSON.parse(event.target.value));
        setCurrentFieldsData({ ...currentFieldsData, 'IsClosed': event.target.value });
    };

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            if (values.MasterAccountStatusId == 6 || values.MasterAccountStatusId == 14) {
                values.IsClosed = true;
                values.IsDisabled = false;
            }
            else if (values.MasterAccountStatusId == 2 || values.MasterAccountStatusId == 10) {
                values.IsClosed = false;
                values.IsDisabled = false;
            }
            dispatch(updateAccountStatusAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Status Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                }).catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addAccountStatusAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Status Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                }).catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        oncloseModal();
    }

    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }





    return (
        <>
            <Formik
                initialValues={{
                    ...currentFieldsData,
                    StatusTypeId: selectedOptionDropDown?.value || "",
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    Status: yup
                        .string()
                        .label('Status')
                        .trim()
                        .required(getValueFromResource('Status is required', dispatch,t)),
                    StatusTypeId: yup
                        .string()
                        .required(getValueFromResource('StatusTypeId is required', dispatch,t)),
                })}>
                {({ values, handleChange, setFieldValue, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}>
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                      
                                                              <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ?
                                                        //  t('Update')
                                                        getValueFromResource('Update ',dispatch, t) : getValueFromResource('Add ',dispatch, t)} {getValueFromResource('Status', dispatch, t)}
                                                        </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className="mb-0">
                                                                <label className="fs-7 fw-normal">
                                                                    {/* {t('Status')} */}
                                                                    {getValueFromResource('Status',dispatch, t)}

                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal mt-2" id='Status' value={values.Status} name='AccountEmployeeType'
                                                                    onChange={handleChange('Status')}
                                                                    // onBlur={() => setFieldTouched('DepartmentCode')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom: 5 }}>
                                                                {touched.Status && errors.Status &&
                                                                    <p className='errorMsg'>{errors.Status as string}</p>
                                                                }
                                                            </div>

                                                            <div className="mb-0 mt-3">
                                                                <label className="fs-7 fw-normal mb-2">
                                                                    {/* {t('Status Type')} */}
                                                                    {getValueFromResource('Status Type',dispatch, t)}

                                                                    </label>
                                                                <Select
                                                                    value={statusTypeArray.find((option: any) => option.value == values.StatusTypeId)}
                                                                    className="basic-single"
                                                                    classNamePrefix="select"
                                                                    isSearchable={true}
                                                                    name="StatusTypeId"
                                                                    // onBlur={() => setFieldTouched('StatusTypeId', true)}
                                                                    onChange={(selectedOption) => {
                                                                        setSelectedOptionDropDown(selectedOption);
                                                                        handleChange({
                                                                            target: {
                                                                                id: "StatusTypeId",
                                                                                value: selectedOption?.value
                                                                            },
                                                                        });
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                    options={statusTypeArray}
                                                                    styles={dropDownSelectionStyles}
                                                                    maxMenuHeight={maxMenuHeight}         
                                                                isDisabled={Object.keys(selectedRecord).length > 0 ? true : false}
                                                                />
                                                                <div>
                                                                    {touched.StatusTypeId && errors.StatusTypeId &&
                                                                        <p className='errorMsg'>{errors.StatusTypeId as string}</p>
                                                                    }
                                                                </div>
                                                            </div>

                                                            {(!masterAccountStatusIds.includes(currentFieldsData.MasterAccountStatusId)) ? (
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label"></label>
                                                                    <div className="mb-3">
                                                                        <div className="form-check form-check-custom form-check-solid form-check-sm">

                                                                            <input
                                                                                className="form-check-input"
                                                                                id="IsClosedOpen"
                                                                                type="radio"
                                                                                value="false"
                                                                                checked={values.IsClosed === false}
                                                                                onChange={() => setFieldValue('IsClosed', false)}
                                                                            />
                                                                            <label className="form-check-label" style={{ color: '#3f4254', fontWeight: 500 }}>
                                                                                {/* {t('Open')} */}
                                                                                {getValueFromResource('Open',dispatch, t)}

                                                                            </label>

                                                                            <input
                                                                                className="form-check-input ms-8"
                                                                                id="IsClosedClose"
                                                                                type="radio"
                                                                                value="true"
                                                                                checked={values.IsClosed === true}
                                                                                onChange={() => setFieldValue('IsClosed', true)}
                                                                            />
                                                                            <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                                                {/* {t('Cancel')} */}
                                                                                {getValueFromResource('Closed',dispatch, t)}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                            {(Object.keys(selectedRecord).length > 0 && !masterAccountStatusIds.includes(currentFieldsData.MasterAccountStatusId)) ? (
                                                                <div className="col-md-6 mt-2">
                                                                    <label className="fs-7 fw-normal mb-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}

                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px"
                                                                            type="checkbox"
                                                                            checked={values.IsDisabled}
                                                                            id="IsDisabled"
                                                                            name="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}

                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}

                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                        {/* {t('Save')} */}
                                                        {getValueFromResource('Save',dispatch, t)}

                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>

                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

